import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import {
  ClientWorkspacePage as SharedClientWorkspacePage,
} from '@hero/web-components';
import { useOrderAgainConfig } from '@hero/web-hooks';

/**
 * Carrier-dashboard CRM surface mounted under `/crm`.
 *
 * Entity drawers (contact, order, client, invoice, …) mount once in
 * `DashboardLayout` via `AgentEntityDrawers`. Do not mount them here —
 * duplicate `StackedDrawer` hosts share the same Zustand store and
 * double-render sheets on row clicks.
 */
export default function CRMWorkspacePage() {
  const { t } = useTranslation(['m-client', 'dashboard']);
  const { setPageName } = usePageContext();
  const orderAgainConfig = useOrderAgainConfig();

  useEffect(() => {
    setPageName(t('dashboard:CRM.title', { defaultValue: t('workspace.title') }));
  }, [setPageName, t]);

  return (
    <SharedClientWorkspacePage
      displayForUser="carrier"
      orderAgainConfig={orderAgainConfig}
    />
  );
}
